__webpack_require__.p = "/o/ams-osram-frontend-loader/assets/";